import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function Main() {
  const data = [
    {
      id: 1,
      img: "assets/images/resources/testi-1-1.png",
      name: "Ashutosh Prajapati",
      subname: "Senior Manager",
      icon: "fab fa-twitter",
    },
    {
      id: 2,
      img: "assets/images/resources/testi-1-2.png",
      name: "Mahesh bhatt",
      subname: "CEO & Founder",
      icon: "fab fa-pinterest-p",
    },
    {
      id: 3,
      img: "assets/images/resources/testi-1-1.png",
      name: "Richa Das",
      subname: "Senior Manager",
      icon: "fab fa-twitter",
    },
    {
      id: 4,
      img: "assets/images/resources/testi-1-2.png",
      name: "Haniya Khan",
      subname: "CEO & Founder",
      icon: "fab fa-pinterest-p",
    },
    {
      id: 5,
      img: "assets/images/resources/testi-1-1.png",
      name: "wazir Ahmed",
      subname: "Senior Manager",
      icon: "fab fa-twitter",
    },
    {
      id: 6,
      img: "assets/images/resources/testi-1-2.png",
      name: "Abhay Chauhan",
      subname: "CEO & Founder",
      icon: "fab fa-pinterest-p",
    },
    {
      id: 7,
      img: "assets/images/resources/testi-1-1.png",
      name: "Veer Pratap Singh",
      subname: "Senior Manager",
      icon: "fab fa-twitter",
    },
    {
      id: 8,
      img: "assets/images/resources/testi-1-2.png",
      name: "Winston singh",
      subname: "CEO & Founder",
      icon: "fab fa-pinterest-p",
    },
  ];

  return (
    <section className="testimonials-one testimonials-one--about">
      <div className="container">
        {/* <img
          src="assets/images/resources/testi-c-1-2.jpg"
          className="testimonials-one__bg wow fadeInUp"
          data-wow-duration="1500ms"
        /> */}
        <div className="row">
          <div className="col-lg-12">
            <div className="sec-title text-start">
              <p className="sec-title__tagline">our testimonials</p>
              <h3 className="sec-title__title">
                What our Clients Say <br />
                About Us
              </h3>
            </div>
            <Swiper
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
            >
              {data.map((item) => (
                <SwiperSlide key={item.id}>
                  <div
                    className="testimonials-card"
                    style={{ "--accent-color": "#1da1f2" }}
                  >
                    <div className="testimonials-card__top">
                      <div className="testimonials-card__image">
                        <img src={item.img} alt={item.name} />
                      </div>
                      <div className="testimonials-card__top__content">
                        <h3 className="testimonials-card__name">
                          {item.name}
                        </h3>
                        <p className="testimonials-card__designation">
                          {item.subname}
                        </p>
                      </div>
                    </div>
                    <div className="testimonials-card__content">
                      We denounce righteo dislike men to beguiled demoralized
                      charms pleasurecy the moment desire they cannot foresee
                      trouble wise man therefore always
                    </div>
                    <div className="testimonials-card__bottom">
                      <div className="testimonials-card__icon">
                        <i className={`${item.icon}`} />
                      </div>
                      <div className="testimonials-card__bottom__content">
                        <h3 className="testimonials-card__review">
                          Quality Services
                        </h3>
                        <p className="testimonials-card__stars">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Main;
